<ng-container *ngIf="!infoCargada">
  <loading></loading>
</ng-container>
<ng-container *ngIf="infoCargada">
  <div class="contentPrincipal" fxLayout="row" fxLayoutAlign="space-between stretch" fxLayout.xs="column" fxLayout.sm="column">
    <div class="contenIzquierdo"  fxLayout="column"  fxLayoutAlign="start stretch">
      <ng-container *ngIf="jsonCustomHome!=undefined">
        <ng-container *ngIf="jsonCustomHome.welcome!=undefined">
          <div class="content_welcom" fxLayout="row" fxLayoutAlign="space-between start"  fxLayout.xs="column">
            <div class="welcom" fxLayout="column" fxLayoutAlign="center start" >
              <h1 class="animated fadeInUp delay-1s" *ngIf="infoUsuario != undefined">
                <b class="tagUsuario" *ngIf="jsonCustomHome != undefined">{{jsonCustomHome.welcome.labelWelcome[idiomaActual]}} {{infoUsuario.user}}!</b>
              </h1>
              <button mat-flat-button color="warn" [tabindex]="-1" class="botNomEmpresa animated fadeInUp delay-1_5s" *ngIf="infoEmpresa != undefined && jsonCustomHome != undefined">
                {{jsonCustomHome.welcome.labelCompany[idiomaActual]}} {{infoEmpresa.nombreEmpresa}}
              </button>
            </div>
            <img *ngIf="jsonCustomHome != undefined" [src]="jsonCustomHome.welcome.image" alt="" class="animated fadeInUp delay-1s">
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="jsonCustomHome!=undefined">
        <ng-container *ngIf="jsonCustomHome.content2.length > 0">
          <ng-container *ngFor="let content2 of jsonCustomHome.content2;let i=index">
            <div class="" style="100%important">
              <ng-container [ngSwitch]="content2.key">
                <ng-container *ngSwitchCase="'cat_product_activ'" >
                  <ng-container *ngIf="cardsCatego!=undefined && cargando">
                    <content-products [datoProducts]="content2" [cardsCatego]="cardsCatego" [jsonCustomHome]="jsonCustomHome" [idSplide]="'productos'"></content-products>
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'cat_result_activ'">
                  <ng-container *ngIf="cardsCatego!=undefined && cargando">
                    <content-products [datoProducts]="content2" [cardsCatego]="cardsCatego" [jsonCustomHome]="jsonCustomHome" [idSplide]="'resultados'"></content-products>
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'cat_public'">
                  <ng-container *ngIf="cargando">
                      <content-video [datoPublic]="content2"></content-video>
                  </ng-container>
                </ng-container>
              </ng-container>

            </div>

          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <div class="contenDerecho" fxLayout="column" fxLayoutAlign="start stretch">
      <ng-container *ngIf="jsonCustomHome!=undefined">
        <ng-container *ngIf="jsonCustomHome.content3.length > 0">
          <div class="" *ngFor="let content3 of jsonCustomHome.content3">
            <ng-container [ngSwitch]="content3.key">
              <ng-container *ngSwitchCase="'splide'">
                <content-sliders [datoSlider]="content3"></content-sliders>
              </ng-container>
              <ng-container *ngSwitchCase="'activity'">
                <content-activity [datoActivity]="content3" [historyEventCompany]="historyEventCompany"></content-activity>
              </ng-container>
            </ng-container>
          </div>

        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>
